<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headersByType"
      :items="items"
      :items-per-page="itemsPerPage"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.order_number="{ item }">
        <span class="mr-2">{{ item.order_number }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="getViewRouteByType(item)"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">mdi-eye-outline</v-icon>
            </template>
            <span v-if="item.order_number">{{ item.order_number }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.customer="{ item }">
        <span class="mr-2">{{ item.customer }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="
            item.person_id
              ? {
                  name: 'persons.show',
                  params: { id: item.person_id }
                }
              : item.company_id
              ? {
                  name: 'companies.show',
                  params: { id: item.company_id }
                }
              : ''
          "
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">mdi-eye-outline</v-icon>
            </template>
            <span v-if="item.customer">{{ item.customer }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.order_status="{ item }">
        <v-chip
          :color="item.order_status_color"
          :text-color="item.order_status_font_color"
        >
          {{ item.order_status }}
        </v-chip>
      </template>

      <template v-slot:item.service_title="{ item }">
        <span class="mr-2">{{ item.service_title }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="
            item.service_type === 2
              ? {
                  name: 'customer-service.show',
                  params: { id: item.service_id }
                }
              : item.service_type === 3
              ? {
                  name: 'internal-service.show',
                  params: { id: item.service_id }
                }
              : ''
          "
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">mdi-eye-outline</v-icon>
            </template>
            <span v-if="item.service_title">{{ item.service_title }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.date_entered="{ item }">
        {{ item.date_entered | dateFormat }}
      </template>
      <template v-slot:item.date_service_expected="{ item }">
        {{ item.date_service_expected | dateFormat }}
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          :route-name="routeName(item)"
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>

      <template v-slot:item.contact_person="{ item }">
        {{ item.contact_person || '-' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import { getViewRouteNameByOrderType } from '@/modules/orders/common/utils';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listItems from '@/modules/_global/mixins/list-items';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'OrdersList',
  components: { ActionSlotComponent },

  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData, listItems],

  props: {
    type: {
      type: String,
      default: 'all',
      validator: prop => ['c', 'b', 'all'].includes(prop)
    }
  },

  data: () => ({
    columnsByType: {
      c: [0, 1, 2, 6, 8, 10],
      b: [0, 1, 2, 5, 8, 9, 10],
      all: [0, 1, 2, 4, 5, 6, 7, 8, 10]
    }
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ORDERS.DATE_ENTERED'),
          sortable: true,
          value: 'date_entered'
        },
        {
          text: this.$t('ORDERS.ORDER_NUMBER'),
          sortable: true,
          value: 'order_number'
        },
        {
          text: this.$t('ORDERS.SERVICE_NAME'),
          sortable: true,
          value: 'service_title'
        },
        {
          text: this.$t('ORDERS.DATE_SERVICE_EXPECTED'),
          sortable: true,
          value: 'date_service_expected'
        },
        {
          text: this.$t('ITEM.GROUP'),
          sortable: true,
          value: 'group'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          sortable: true,
          value: 'building_complex_name'
        },
        {
          text: this.$t('ORDERS.SOURCE'),
          sortable: true,
          value: 'source'
        },
        {
          text: this.$t('ORDERS.CUSTOMER'),
          sortable: true,
          value: 'customer'
        },
        {
          text: this.$t('ORDERS.ORDER_STATUS'),
          sortable: true,
          value: 'order_status'
        },
        {
          text: this.$t('CONTACT_PERSONS.ITEM'),
          sortable: true,
          value: 'contact_person'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  methods: {
    routeName(item) {
      return getViewRouteNameByOrderType(item.type_id);
    },
    getViewRouteByType(item) {
      const routeName = getViewRouteNameByOrderType(item.type_id);

      if (routeName) {
        return {
          name: routeName,
          params: { id: item.id }
        };
      }
    }
  }
};
</script>
